import { render, staticRenderFns } from "./InsuranceCompanyManagement.vue?vue&type=template&id=18efb74b&scoped=true&"
import script from "./InsuranceCompanyManagement.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyManagement.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyManagement.vue?vue&type=style&index=0&id=18efb74b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18efb74b",
  null
  
)

export default component.exports